<!--
===========================================================================
  Tibia Calcs GPL Source Code
  Copyright (C) 2020 Lucas Soares de Miranda
  Copyright (C) 2020 Luiz Claudio Soares de Miranda

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <http://www.gnu.org/licenses/>.

  License available on https://github.com/lucasoares/tibia-calcs/blob/main/LICENSE.md
===========================================================================
-->

<template>
  <v-app>
    <NavBar />
    <main class="main">
      <router-view class="" />
      <notifications position="bottom right" />
      <!-- <v-footer class="d-flex flex-column footer margin">
        <div class="bg-teal d-flex w-100 align-center px-4">
          <strong>All Rights Reserved</strong>

          <v-spacer></v-spacer>

          <v-btn v-for="icon in icons" :key="icon" class="mx-4" :icon="icon" variant="plain" size="small"></v-btn>
        </div>

        <div class="px-4 py-2 bg-black text-center w-100">
          {{ new Date().getFullYear() }} — <strong>Tibia-Calcs</strong>
        </div>
        <div>
          Tibia is copyrighted by CipSoft GmbH. The official website for Tibia is Tibia.com
        </div>
      </v-footer> -->
    </main>

  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from './components/NavBar.vue';

export default {
  name: 'App',
  methods: {
    ...mapGetters('settings', [
      'getDarkTheme',
    ]),
  },
  created() {
    this.$vuetify.theme.dark = this.getDarkTheme();
  },
  components: {
    NavBar,
  },
};
</script>

<style>
.margin {
  margin: 6rem 3% 0rem;
}

.footer {
  border-radius: 25px !important;
  width: 94%;
  height: 100px;
  bottom: 0;
  left: 0;
  position: absolute !important;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  height: 100vw;
}

#main-title {
  font-size: 2rem;
  margin-bottom: 1rem;
}

body {
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
}

html {
  height: -webkit-fill-available;
}

.v-application--wrap {
  min-height: unset;
}

main {
  padding: 2rem;
  margin: 6rem 3% 3rem;
  border-radius: 25px;
}
</style>
